// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AYNSICJ_80sHNKCVrFKq0 {\n  position: relative;\n  border: 1px solid #DCDCDC;\n  border-radius: 4px;\n  width: 140px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n}\n\n._7umJLh4cXDex6Nd19Bafw {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  color: #B8B8B8;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 10px;\n} ", ""]);
// Exports
exports.locals = {
	"container": "AYNSICJ_80sHNKCVrFKq0",
	"buttonContent": "_7umJLh4cXDex6Nd19Bafw"
};
module.exports = exports;
